export const PUBLICATIONS_INITIAL_FORM = {
  titre: "",
  description: "",
  image_publication_url: "",
  lien_publication_url: "",
  is_active: true,
};

export const PUBLICATIONS_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Toutes",
    description: "Afficher toutes les publications.",
  },
  {
    value: "active",
    label: "Publiées",
    description: "Visibles sur le site public.",
  },
  {
    value: "inactive",
    label: "Brouillons",
    description: "Masquées du site public.",
  },
];

export const PUBLICATIONS_LIMIT_OPTIONS = [12, 24, 48, 96];

export const PUBLICATIONS_FORM_HELPERS = [
  "Utilisez un titre clair pour identifier rapidement le document.",
  "Ajoutez une image pour rendre la publication plus attractive.",
  "Le lien peut pointer vers un PDF, une page interne ou un site externe.",
];

export const PUBLICATIONS_MEDIA_CATEGORY_DEFAULT = "publications";